import { render } from "./PatientWaitingListDatatableActions.vue?vue&type=template&id=311b2b52"
import script from "./PatientWaitingListDatatableActions.vue?vue&type=script&lang=js"
export * from "./PatientWaitingListDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__